import { Plugin, PluginKey, Transaction, EditorState } from 'prosemirror-state'
import { ReplaceStep } from 'prosemirror-transform'
import { MentionClient } from 'api/clients/MentionClient'
import { ArticleFlat } from 'types'

export const MENTIONS_PLUGIN_KEY = new PluginKey('mentions')

// Creates a Prosemirror plugin that enables interactions of mentions with
// the surrounding application.
//
// More specifically, it handles the following behaviours:
// - When deleting the text of a mention, delete the corresponding mention.
const MentionsPlugin = (article: ArticleFlat): Plugin => {
  return new Plugin({
    key: MENTIONS_PLUGIN_KEY,
    state: {
      init(_config) {
        return {}
      },
      apply(tx: Transaction, state: {}, oldEditorState: EditorState) {
        syncMentionsFromTransaction(tx, oldEditorState, article)

        return state
      },
    },
  })
}

const syncMentionsFromTransaction = (tx: Transaction, previousEditorState: EditorState, article: ArticleFlat) => {
  const replaceSteps = tx.steps.filter((step) => step instanceof ReplaceStep)

  const deletedUserMentions: string[] = []
  const deletedArticleMentions: string[] = []

  if (replaceSteps.length > 0 && tx.getMeta('source') !== 'remote') {
    for (const step of replaceSteps) {
      const { from: replaceStart, to: replaceEnd } = step.toJSON()
      if (replaceStart === replaceEnd) {
        continue
      }
      if (previousEditorState.doc.nodeSize - 1 > replaceEnd) {
        previousEditorState.doc.nodesBetween(replaceStart, replaceEnd, (node, pos) => {
          if (pos >= replaceStart && pos + node.nodeSize <= replaceEnd) {
            if (node.type === previousEditorState.schema.nodes.smartLink && (node.attrs.key || node.attrs.userId)) {
              if (node.attrs.type === 'Article') {
                deletedArticleMentions.push(node.attrs.key)
              } else if (node.attrs.type === 'User') {
                deletedUserMentions.push(node.attrs.userId)
              }
            }
          }
        })
      }
    }
  }
  if (deletedUserMentions.length > 0) {
    MentionClient.batchDeleteMentionedUsers(deletedUserMentions, article.id)
  }
  if (deletedArticleMentions.length > 0) {
    MentionClient.batchDeleteMentionedArticles(deletedArticleMentions, article.id)
  }
}
export { MentionsPlugin }
